import { useQuery } from '@tanstack/react-query';
import {
  fetchStacks,
  fetchAllResources,
  fetchInfrastructureSummary,
} from '@/api/infrastructure';
import type { StackListParams, ResourceListParams } from '@/api/infrastructure';

export function useStacks(params?: StackListParams) {
  return useQuery({
    queryKey: ['stacks', params],
    queryFn: () => fetchStacks(params),
    staleTime: 5 * 60 * 1000,
  });
}

export function useResources(params?: ResourceListParams) {
  return useQuery({
    queryKey: ['resources', params],
    queryFn: () => fetchAllResources(params),
    staleTime: 5 * 60 * 1000,
  });
}

export function useInfrastructureSummary() {
  return useQuery({
    queryKey: ['infrastructure-summary'],
    queryFn: fetchInfrastructureSummary,
    staleTime: 5 * 60 * 1000,
  });
}
